import { CheckCircle2, ArrowRight, MessageSquare, Linkedin } from 'lucide-react';

export default function ThankYou() {
  const currentDeviceCode = localStorage.getItem('selyo_device_signature') || 'CF-8300-RECOVERY';

  return (
    <div className="min-h-screen bg-white text-slate-950 flex flex-col justify-between antialiased">
      {/* Top Heritage Border Framing Line */}
      <div className="h-1.5 w-full bg-gradient-to-r from-[#008751] via-white to-[#D22630]" />

      <main className="max-w-xl mx-auto px-4 py-16 text-center my-auto">
        <div className="h-16 w-16 bg-[#008751]/10 text-[#008751] rounded-full flex items-center justify-center mx-auto mb-6 border border-[#008751]/20">
          <CheckCircle2 className="h-8 w-8" />
        </div>

        <h1 className="text-2xl sm:text-4xl font-black uppercase tracking-tight mb-3 text-slate-900">
          Maraming Salamat!
        </h1>
        <p className="text-[#008751] font-bold text-sm sm:text-base uppercase tracking-wide mb-8">
          Ang iyong 1-Year Space operational license ay handa na para sa activation pagkatapos ng verification checks.
        </p>

        {/* Action Panel Checklist */}
        <div className="bg-[#F8F9FA] border border-slate-200 rounded-2xl p-6 text-left space-y-6 shadow-sm">
          <h3 className="text-xs font-black uppercase tracking-widest text-slate-500 border-b border-slate-200 pb-2">
            Paano i-activate ang iyong 1-Year Operational Pass:
          </h3>

          <div className="flex gap-4">
            <div className="h-6 w-6 rounded-full bg-[#008751] text-white font-bold text-xs flex items-center justify-center shrink-0 mt-0.5">1</div>
            <div>
              <h4 className="text-xs font-bold uppercase text-slate-900">Suriin ang iyong Resibo</h4>
              <p className="text-[11px] text-slate-600 font-medium leading-relaxed mt-0.5">
                Magpapadala ang aming system core ng official payment status record sa inyong registered registration data streams.
              </p>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="h-6 w-6 rounded-full bg-[#008751] text-white font-bold text-xs flex items-center justify-center shrink-0 mt-0.5">2</div>
            <div className="w-full">
              <h4 className="text-xs font-bold uppercase text-slate-900">Ibigay ang iyong Crypto Device Signature</h4>
              <p className="text-[11px] text-slate-600 font-medium leading-relaxed mt-0.5 mb-2">
                Ito ang iyong permanenteng on-device hardware fingerprint locker key:
              </p>
              <div className="bg-slate-950 text-emerald-400 px-3 py-2 rounded-lg font-mono text-xs border border-slate-800 tracking-wider">
                {currentDeviceCode}
              </div>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="h-6 w-6 rounded-full bg-[#008751] text-white font-bold text-xs flex items-center justify-center shrink-0 mt-0.5">3</div>
            <div className="space-y-2 w-full">
              <h4 className="text-xs font-bold uppercase text-slate-900">I-send ang detalye kay Nisi Ryan Cruz</h4>
              <p className="text-[11px] text-slate-600 font-medium leading-relaxed mt-0.5">
                I-send ang screenshot ng inyong payment reference kasama ang inyong Device Code sa aming official channels upang makuha ang iyong Activation Token:
              </p>
              <div className="grid grid-cols-2 gap-2 text-[10px] font-bold uppercase tracking-wider pt-1">
                <a href="https://www.facebook.com/nisiryancruz" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-1.5 border border-slate-200 bg-white py-2.5 rounded-lg text-slate-700 shadow-sm hover:bg-slate-50 transition-all">
                  <MessageSquare className="h-3.5 w-3.5 text-blue-600" /> Messenger
                </a>
                <a href="https://www.linkedin.com/in/nisi-ryan-cruz-69922212b/" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-1.5 bg-[#008751] text-white py-2.5 rounded-lg shadow-sm hover:bg-[#006e41] transition-all">
                  <Linkedin className="h-3.5 w-3.5" /> LinkedIn
                </a>
              </div>
              <div className="border-t border-slate-200 pt-3 mt-3 flex flex-col sm:flex-row justify-between text-[9px] text-slate-500 font-mono gap-2">
                <div>
                  <span className="font-bold text-slate-700">Support Email:</span>{' '}
                  <a href="mailto:nisiryancruz@gmail.com" className="text-[#008751] hover:underline font-bold">
                    nisiryancruz@gmail.com
                  </a>
                </div>
                <div>
                  <span className="font-bold text-slate-700">Telegram / Viber:</span>{' '}
                  <span className="font-bold text-[#008751]">09752610905</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <a href="/" className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#008751] hover:text-[#006e41] transition-all underline">
            Bumalik sa Main Terminal <ArrowRight className="h-3.5 w-3.5" />
          </a>
        </div>
      </main>

      <footer className="border-t border-slate-200 py-6 text-center text-[10px] text-slate-400 font-medium bg-white">
        Selyo Utility Stack © 2026. Handled securely under local client database structures.
      </footer>
    </div>
  );
}
